import axios from 'axios'
import { ApiResponse, AsessFilterDto } from '../models/Base'
import { SelfAssessDto, SelfAssessRequestDto, SelfAssessSettingRequestDto, SelfAssessValidateDto, SelfValidateFilterDto, TableDto, ValidateUpdateRequestDto } from '../models/dto/SelfAssessment'

const API_URL = process.env.REACT_APP_API_URL
const SELF_ASESSMENT_URL = `${API_URL}/self-assesses`


export function GetById(date:string) {
    return axios.post<ApiResponse<TableDto>>(`${SELF_ASESSMENT_URL}/search`)
}

export function GetByPeriod(period:string){
    return axios.get<ApiResponse<SelfAssessDto[]>>(`${SELF_ASESSMENT_URL}/period/${period}`)
}

export function Search(payload: AsessFilterDto) {
    return axios.post<ApiResponse<TableDto>>(`${SELF_ASESSMENT_URL}/search`, payload)
}

export function SearchSelfSettingValidate(payload: SelfValidateFilterDto) {
    return axios.post<ApiResponse<SelfAssessValidateDto[]>>(`${SELF_ASESSMENT_URL}/settings/self-validate`, payload)
}

export function CreateMany(payload: SelfAssessRequestDto[]) {
    return axios.post(`${SELF_ASESSMENT_URL}/many`, payload)
}
export function UpdatePeriod(period: string, payload: SelfAssessRequestDto[]) {
    return axios.put(`${SELF_ASESSMENT_URL}/period/${period}`,payload)
}

export function GetSelfAssesssSettingById(id:number) {
    return axios.get<ApiResponse<SelfAssessDto>>(`${SELF_ASESSMENT_URL}/settings/self-assess/${id}`)
}
export function GetSelfAssesssSetting() {
    return axios.get<ApiResponse<SelfAssessDto[]>>(`${SELF_ASESSMENT_URL}/settings/self-assess`)
}
export function UpdateSelfAssesss(id: number, payload: SelfAssessSettingRequestDto) {
    return axios.put(`${SELF_ASESSMENT_URL}/settings/self-assess/${id}`,payload)
}


export function UpdateSelfValidate(id: number, payload: ValidateUpdateRequestDto) {
    return axios.put(`${SELF_ASESSMENT_URL}/settings/self-validate/${id}`,payload)
}

export function DeleteSelfValidate(id:number){
    return axios.delete(`${SELF_ASESSMENT_URL}/settings/self-validate/${id}`)
}
